(() => {
  if (window.gmlAuthFlowReady) return;
  window.gmlAuthFlowReady = true;

  const messages = {
    en: {
      title: 'Secure verification',
      email: 'Complete email verification in the secure sign-in window. This page will update after you sign in.',
      google: 'Complete Google sign-in in the secure window. This page will update after you sign in.',
      closed: 'If the secure window is unavailable, you can continue sign-in below.',
      continue: 'Open secure sign-in',
      back: 'Back',
      emailChoice: 'Sign in with email'
    },
    fr: {
      title: 'Vérification sécurisée',
      email: 'Terminez la vérification de votre adresse courriel dans la fenêtre de connexion sécurisée. Cette page se mettra à jour après votre connexion.',
      google: 'Connectez-vous avec Google dans la fenêtre sécurisée. Cette page se mettra à jour après votre connexion.',
      closed: 'Si la fenêtre sécurisée n’est pas disponible, vous pouvez poursuivre la connexion ci-dessous.',
      continue: 'Continuer la connexion sécurisée',
      back: 'Retour',
      emailChoice: 'Se connecter par courriel'
    },
    es: {
      title: 'Verificación segura',
      email: 'Verifica tu correo electrónico en la ventana de acceso segura. Esta página se actualizará cuando hayas iniciado sesión.',
      google: 'Inicia sesión con Google en la ventana segura. Esta página se actualizará cuando hayas iniciado sesión.',
      closed: 'Si la ventana segura no está disponible, puedes continuar con el inicio de sesión abajo.',
      continue: 'Abrir el acceso seguro',
      back: 'Volver',
      emailChoice: 'Iniciar sesión con correo electrónico'
    },
    ar: {
      title: 'تحقق آمن',
      email: 'أكمل التحقق من بريدك الإلكتروني في نافذة تسجيل الدخول الآمنة. ستُحدَّث هذه الصفحة بعد تسجيل دخولك.',
      google: 'أكمل تسجيل الدخول باستخدام Google في النافذة الآمنة. ستُحدَّث هذه الصفحة بعد تسجيل دخولك.',
      closed: 'إذا تعذّر استخدام النافذة الآمنة، يمكنك متابعة تسجيل الدخول أدناه.',
      continue: 'فتح تسجيل الدخول الآمن',
      back: 'رجوع',
      emailChoice: 'تسجيل الدخول بالبريد الإلكتروني'
    },
    it: {
      title: 'Verifica sicura',
      email: 'Completa la verifica dell’indirizzo e-mail nella finestra di accesso sicuro. Questa pagina si aggiornerà dopo l’accesso.',
      google: 'Completa l’accesso con Google nella finestra sicura. Questa pagina si aggiornerà dopo l’accesso.',
      closed: 'Se la finestra sicura non è disponibile, puoi continuare l’accesso qui sotto.',
      continue: 'Apri l’accesso sicuro',
      back: 'Indietro',
      emailChoice: 'Accedi con e-mail'
    },
    zh: {
      title: '安全验证',
      email: '请在安全登录窗口中完成电子邮件验证。登录成功后，此页面将自动更新。',
      google: '请在安全窗口中完成 Google 登录。登录成功后，此页面将自动更新。',
      closed: '如果无法使用安全窗口，您可以在下方继续登录。',
      continue: '打开安全登录',
      back: '返回',
      emailChoice: '使用电子邮件登录'
    }
  };
  const language = (document.documentElement.lang || 'en').split('-')[0].toLowerCase();
  const copy = messages[language] || messages.en;
  const controllers = new Set();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktopPopup = () => window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)').matches;
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    if (text) element.textContent = text;
    return element;
  };
  const icon = path => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.4');
    svg.setAttribute('aria-hidden', 'true');
    const shape = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    shape.setAttribute('d', path);
    svg.append(shape);
    return svg;
  };
  const safeDestination = value => {
    const fallback = window.location.pathname + window.location.search + window.location.hash;
    if (!value || !value.startsWith('/') || value.startsWith('//')) return fallback;
    const url = new URL(value, window.location.origin);
    return url.origin === window.location.origin ? url.pathname + url.search + url.hash : fallback;
  };
  const storefrontLogin = value => {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && url.pathname === '/customer_authentication/login' ? url : null;
    } catch { return null; }
  };

  const mount = root => {
    if (root.dataset.gmlAuthMounted) return;
    const options = root.querySelector('.gml-sign-in-options');
    const form = root.querySelector('[data-gml-email-sign-in]');
    const emailInput = form?.querySelector('input[name="login_hint"]');
    const google = root.querySelector('[data-gml-sign-in="google"]');
    if (!options || !form || !emailInput || !google) return;
    root.dataset.gmlAuthMounted = 'true';

    const choices = make('div', 'gml-auth-flow__view');
    const emailView = make('div', 'gml-auth-flow__view');
    const secureView = make('div', 'gml-auth-flow__view gml-auth-flow__status');
    const emailChoice = make('button', 'gml-sign-in-option');
    emailChoice.type = 'button';
    emailChoice.append(icon('M3 6h18v12H3z M3 6l9 7 9-7'), make('span', '', root.dataset.emailChoice || copy.emailChoice));
    choices.append(google, emailChoice);

    const backButton = () => {
      const button = make('button', 'gml-auth-flow__back');
      button.type = 'button';
      button.append(icon('m14 5-7 7 7 7'), make('span', '', root.dataset.backLabel || copy.back));
      return button;
    };
    const emailBack = backButton();
    const secureBack = backButton();
    emailView.append(emailBack, form);
    const secureTitle = make('h3', '', copy.title);
    const secureMessage = make('p', '');
    secureMessage.setAttribute('role', 'status');
    secureMessage.setAttribute('aria-live', 'polite');
    const continueLink = make('a', 'gml-sign-in-option', copy.continue);
    continueLink.rel = 'nofollow';
    secureView.append(secureBack, secureTitle, secureMessage, continueLink);
    options.replaceChildren(choices, emailView, secureView);
    emailView.hidden = true;
    secureView.hidden = true;
    root.dataset.gmlAuthState = 'choices';

    const views = { choices, email: emailView, secure: secureView };
    let current = 'choices';
    let animation;
    let popup = null;
    let timer = null;
    let pending = null;
    let checking = false;
    let lastMethod = 'email';

    const show = (name, focusTarget) => {
      animation?.cancel();
      const before = root.getBoundingClientRect().height;
      for (const [key, view] of Object.entries(views)) {
        view.hidden = key !== name;
        view.inert = key !== name;
      }
      current = name;
      root.dataset.gmlAuthState = name;
      const after = root.getBoundingClientRect().height;
      if (!reducedMotion.matches && typeof root.animate === 'function') {
        animation = root.animate([{ height: `${before}px`, opacity: .55 }, { height: `${after}px`, opacity: 1 }], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' });
        views[name].animate([{ transform: 'translateY(8px)' }, { transform: 'none' }], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
      requestAnimationFrame(() => {
        if (!root.isConnected || views[name].hidden || root.closest('dialog')?.open === false) return;
        focusTarget?.focus({ preventScroll: true });
      });
    };
    const stopPolling = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };
    const finish = () => {
      if (!pending) return;
      const destination = pending.destination;
      pending = null;
      stopPolling();
      try { popup?.close(); } catch {}
      window.location.assign(destination);
    };
    const verifyStorefrontSession = async () => {
      if (!pending || checking || !root.isConnected) return;
      checking = true;
      const abort = new AbortController();
      const timeout = window.setTimeout(() => abort.abort(), 5000);
      try {
        const response = await fetch(window.location.pathname + window.location.search, { credentials: 'same-origin', cache: 'no-store', signal: abort.signal });
        if (!response.ok || new URL(response.url).origin !== window.location.origin) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (html.querySelector('[data-gml-authenticated="true"]')) finish();
      } catch {} finally {
        window.clearTimeout(timeout);
        checking = false;
      }
    };
    const poll = () => {
      if (!pending || !root.isConnected || Date.now() - pending.started > 600000) {
        stopPolling();
        return;
      }
      try {
        if (popup && !popup.closed && popup.location.origin === window.location.origin && popup.document.querySelector('[data-gml-authenticated="true"]')) {
          finish();
          return;
        }
        if (popup?.closed) {
          stopPolling();
          secureMessage.textContent = copy.closed;
          verifyStorefrontSession();
        }
      } catch {}
    };
    const launch = (url, method) => {
      stopPolling();
      if (popup && !popup.closed) {
        try { popup.close(); } catch {}
      }
      const destination = safeDestination(url.searchParams.get('return_to'));
      url.searchParams.set('return_to', destination);
      const width = 520;
      const height = 720;
      const left = Math.max(0, window.screenX + (window.outerWidth - width) / 2);
      const top = Math.max(0, window.screenY + (window.outerHeight - height) / 2);
      popup = window.open('about:blank', '_blank', `popup=yes,width=${width},height=${height},left=${Math.round(left)},top=${Math.round(top)}`);
      if (!popup) {
        window.location.assign(url.href);
        return;
      }
      try {
        popup.opener = null;
        popup.location.replace(url.href);
      } catch {
        try { popup.close(); } catch {}
        window.location.assign(url.href);
        return;
      }
      lastMethod = method;
      pending = { destination, started: Date.now() };
      secureMessage.textContent = copy[method];
      continueLink.href = url.href;
      show('secure', continueLink);
      timer = window.setInterval(poll, 700);
    };

    emailChoice.addEventListener('click', () => show('email', emailInput));
    emailBack.addEventListener('click', () => show('choices', emailChoice));
    secureBack.addEventListener('click', () => {
      stopPolling();
      pending = null;
      try { popup?.close(); } catch {}
      show(lastMethod === 'email' ? 'email' : 'choices', lastMethod === 'email' ? emailInput : google);
    });
    form.addEventListener('submit', event => {
      if (!desktopPopup() || !form.reportValidity()) return;
      const url = storefrontLogin(form.action);
      if (!url) return;
      for (const [key, value] of new FormData(form)) url.searchParams.set(key, String(value));
      event.preventDefault();
      launch(url, 'email');
    });
    google.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !desktopPopup()) return;
      const url = storefrontLogin(google.href);
      if (!url) return;
      event.preventDefault();
      launch(url, 'google');
    });
    root.closest('dialog')?.addEventListener('close', () => {
      pending = null;
      stopPolling();
      try { popup?.close(); } catch {}
      popup = null;
      show('choices');
    });
    controllers.add({ check: verifyStorefrontSession });
  };

  const initialize = () => document.querySelectorAll('[data-gml-auth-flow]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('focus', () => controllers.forEach(controller => controller.check()));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') controllers.forEach(controller => controller.check());
  });
})();
